import { connect } from 'react-redux';
import AdvisorEnded from './advisor_ended';
import withPGTranslation from '../../../config/withPGTranslation';
import { hangupVoipChat } from '../../../actions/voip_chat';
import { hangupChat } from '../../../actions/chat';

const mapStateToProps = ({ voipChat, chat }) => ({
  voipChatState: voipChat && voipChat.voipState,
  textChatstate: chat && chat.state
});

export default connect(mapStateToProps, {
  hangupVoipChat,
  hangupChat
})(withPGTranslation(AdvisorEnded));
